<div class="row">
    <div class="form-group col-12 col-md-4">
        <label for="resumoValorTotal" class="col-form-label">Total</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">{{entity?.quantidadeTotal | decimalFormat: 1:0:0}}</span>
            </div>
            <input type="text" class="form-control text-right" [value]="entity?.valorTotal | currencyFormat: 1:2:2" name="resumoValorTotal"
                id="resumoValorTotal" disabled="disabled" readonly="readonly">
        </div>
    </div>
    <div class="form-group col-12 col-md-4">
        <label for="resumoValorPago" class="col-form-label">Pagos</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">{{entity?.quantidadePago | decimalFormat: 1:0:0}}</span>
            </div>
            <input type="text" class="form-control text-right" [value]="entity?.valorPago | currencyFormat: 1:2:2" name="resumoValorPago"
                id="resumoValorPago" disabled="disabled" readonly="readonly">
        </div>
    </div> 
    <div class="form-group col-12 col-md-4">
        <label for="resumoValorAberto" class="col-form-label">Em Aberto</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">{{entity?.quantidadeAberto | decimalFormat: 1:0:0}}</span>
            </div>
            <input type="text" class="form-control text-right" [value]="entity?.valorAberto | currencyFormat: 1:2:2" name="resumoValorAberto"
                id="resumoValorAberto" disabled="disabled" readonly="readonly">
        </div>
    </div>                                                                                                             
</div>
<div class="row">                        
    <div class="form-group col-12 col-md-4">
        <label for="resumoValorVencido" class="col-form-label">Vencidos</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">{{entity?.quantidadeVencido | decimalFormat: 1:0:0}}</span>
            </div>
            <input type="text" class="form-control text-right" [value]="entity?.valorVencido | currencyFormat: 1:2:2" name="resumoValorVencido"
                id="resumoValorVencido" disabled="disabled" readonly="readonly">
        </div>
    </div>                                       
    <div class="form-group col-12 col-md-4">
        <label for="resumoMediaPagamentoEmAtraso" class="col-form-label">Média de Pagto. em Atraso</label>
        <div class="input-group">
            <input type="text" class="form-control text-right" [value]="entity?.mediaPagamentoEmAtraso | decimalFormat: 1:2:2" name="resumoMediaPagamentoEmAtraso"
                id="resumoMediaPagamentoEmAtraso" disabled="disabled" readonly="readonly">
            <div class="input-group-append">
                <span class="input-group-text">Dia(s)</span>
            </div>
        </div>
    </div> 
    <div class="form-group col-12 col-md-4">
        <label for="resumoMaiorAtraso" class="col-form-label">Maior Atraso</label>
        <div class="input-group">
            <input type="text" class="form-control text-right" [value]="entity?.maiorAtraso" name="resumoMaiorAtraso"
                id="resumoMaiorAtraso" disabled="disabled" readonly="readonly">
            <div class="input-group-append">
                <span class="input-group-text">Dia(s)</span>
            </div>
        </div>
    </div>  
</div>
<div class="row">
    <div class="form-group col-12 col-md-4">
        <label for="resumoPrazoMedioPagamento" class="col-form-label">Prazo Médio de Pagamento</label>
        <input type="text" class="form-control text-right" [value]="entity?.prazoMedioPagamento | decimalFormat: 1:2:2" name="resumoPrazoMedioPagamento"
            id="resumoPrazoMedioPagamento" disabled="disabled" readonly="readonly">
    </div>      
    <div class="form-group col-12 col-md-4">
        <label for="resumoPrazoMedioVencimento" class="col-form-label">Prazo Médio de Vencimento</label>
        <input type="text" class="form-control text-right" [value]="entity?.prazoMedioVencimento | decimalFormat: 1:2:2" name="resumoPrazoMedioVencimento"
            id="resumoPrazoMedioVencimento" disabled="disabled" readonly="readonly">
    </div>
    <div class="form-group col-12 col-md-4">
        <label for="resumoPrazoMedioEmAberto" class="col-form-label">Prazo Médio em Aberto</label>
        <input type="text" class="form-control text-right" [value]="entity?.prazoMedioEmAberto | decimalFormat: 1:2:2" name="resumoPrazoMedioEmAberto"
            id="resumoPrazoMedioEmAberto" disabled="disabled" readonly="readonly">
    </div>        
</div>